import { render } from "./humanityLibraryManage.vue?vue&type=template&id=5b97f2ec&scoped=true"
import script from "./humanityLibraryManage.vue?vue&type=script&lang=js"
export * from "./humanityLibraryManage.vue?vue&type=script&lang=js"

import "./humanityLibraryManage.vue?vue&type=style&index=0&id=5b97f2ec&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b97f2ec"]])

export default __exports__